import React, { Component, Fragment } from "react";
import ReportScope, { readReportScope } from '../../reports/report-scope';
import { injectIntl } from "react-intl";
import { DatePicker, RangeDatePicker } from "jalali-react-datepicker";
import API from "../../../api/index";
var classNames = require("classnames");
import ReactTimeAgo from "react-time-ago";
import { NotificationManager } from "Components/ReactNotifications";
import moment from "jalali-moment";

import { logoutUser } from "Redux/actions";
import { connect } from "react-redux";
import CustomSelectInput from "Components/CustomSelectInput";
import Select from "react-select";
import { Row, Card, CardBody, CardTitle, Button, Collapse, FormGroup, Label, Input, Form, timeoutsShape, Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";

import NumberFormat from "react-number-format";
import { Colxx, Separator } from "Components/CustomBootstrap";

class archive extends Component {
	constructor(props) {
		super(props);

		this.state = {
			sms_isBatchesLoading: false,
			sms_targetBatchID: -1,
			sms_batches: [],
			sms_searchChanged: false,
			sms_isSending: false,
			sms_targetBatchMessage: "",

			customers: [],
			paging: [],
			isRefreshing: false,
			isLoading: true,
			toggleSearchForm: true,
			APIResetData: {},
			APISearchData: {},
			customerTagName: "",
			search: {
				reportContext: readReportScope(props.location.search),
				smsBanned: this.props.match.params.smsBannedType == "banned" ? "BANNED" : "ALL",
				customerName: "",
				customerSurName: "",
				customerMobile: "",
				gender: "ALL",
				basicInfo: "ALL",
				CustomerTagID: this.props.match.params.customerTagID != undefined ? this.props.match.params.customerTagID : -1,
				ListType: this.props.match.params.listType != undefined ? this.props.match.params.listType : "ALL",
				currentPage: 1,
				nameOperator: "=",
			},
		};

		this.validateMobile = this.validateMobile.bind(this);
		this.setCreatedDateRange = this.setCreatedDateRange.bind(this);
		this.setClosedDateRange = this.setClosedDateRange.bind(this);
		this.handleFocus = this.handleFocus.bind(this);
		this.toggleSearchForm = this.toggleSearchForm.bind(this);
		this.doSearch = this.doSearch.bind(this);
		this.doReset = this.doReset.bind(this);
		this.cleanCustomerMobile = this.cleanCustomerMobile.bind(this);
		this.loadData = this.loadData.bind(this);

		this.syntaxHighlight = this.syntaxHighlight.bind(this);
		this.smsModalToggle = this.smsModalToggle.bind(this);
		this.smsFilters = this.smsFilters.bind(this);
		this.smsModalOpened = this.smsModalOpened.bind(this);
		this.smsSend = this.smsSend.bind(this);
	}
	smsSend() {
		this.setState({ sms_isSending: true });
		API.sms.batch
			.send({ audience: "CUSTOMER", messageType: "ADVERTISING", batchID: this.state.sms_targetBatchID, searchConditions: this.smsFilters() })
			.then((data) => {
				data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;
				if (data.DONE) {
					alert("تعداد کل موبایل ها: " + data.COUNT.TOTAL + "\n" + "تعداد موبایل های مسدود: " + data.COUNT.BANNED + "\n" + "تعداد نهایی برای ارسال: " + data.COUNT.FINAL + "\n");
					this.props.history.push("/app/sms/batch", { tabDefaultIndex: 1 });
				}
			})
			.catch((error) => {
				console.log(error);
				this.setState({
					sms_isSending: false,
				});
			});
	}
	smsFilters() {
		var filters = this.state.search;
		delete filters.currentPage;
		return filters;
	}
	smsModalOpened() {
		this.setState({ sms_isBatchesLoading: true });
		API.sms.batch
			.list({ audience: "CUSTOMER" })
			.then((data) => {
				data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;
				this.setState({
					sms_batches: data.batches,
					sms_isBatchesLoading: false,
				});
			})
			.catch((error) => {});
	}
	smsModalToggle() {
		this.setState({
			smsModalOpen: !this.state.smsModalOpen,
		});
	}
	syntaxHighlight(json) {
		json = json.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
		return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
			var cls = "number";
			if (/^"/.test(match)) {
				if (/:$/.test(match)) {
					cls = "key";
				} else {
					cls = "string";
				}
			} else if (/true|false/.test(match)) {
				cls = "boolean";
			} else if (/null/.test(match)) {
				cls = "null";
			}
			return `<span class="${cls}">${match}</span>`;
		});
	}

	cleanCustomerMobile(mobile) {
		mobile = mobile.split(" ").join("");
		mobile = mobile.replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d)).replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));

		// console.log(mobile,mobile.indexOf("0098"))
		if (mobile.indexOf("0098") === 0) {
			mobile = mobile.replace("0098", "0");
		}
		if (mobile.indexOf("098") === 0) {
			mobile = mobile.replace("098", "0");
		}
		if (mobile.indexOf("+98") === 0) {
			mobile = mobile.replace("+98", "0");
		}
		if (mobile.indexOf("98") === 0) {
			mobile = mobile.replace("98", "0");
		}
		if (mobile.indexOf("9") === 0 && mobile.length == 10) {
			mobile = "0" + mobile;
		}
		return mobile;
	}
	componentDidMount() {
		this.setState(
			{
				APISearchData: JSON.parse(JSON.stringify(this.state.search)),
				APIResetData: JSON.parse(JSON.stringify(this.state.search)),
			},
			() => {
				this.loadData();
			}
		);
	}
	loadData() {
		this.setState({ reportError: '' });
		API.crm.customer
			.list(this.state.APISearchData)
			.then((data) => {
				data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;
				this.setState({
					customers: data.CUSTOMERS,
					paging: data.PAGING,
					customerTagName: data.CUSTOMER_TAG_NAME,
					isLoading: false,
					isRefreshing: false,
					sms_searchChanged: false,
				});
			})
			.catch((error) => { this.setState({ isLoading: false, isRefreshing: false, reportError: 'دریافت فهرست ناموفق بود؛ دسترسی یا فیلتر گزارش را بررسی کنید.', paging: {pages:[],total:0,from:0,to:0,current:1}, orders:[],customers:[],leads:[],coupons:[] }); });
	}
	doSearch() {
		var tmpObj = JSON.parse(JSON.stringify(this.state.search));
		tmpObj.currentPage = 1;
		this.setState(
			{
				APISearchData: tmpObj,
				isRefreshing: true,
			},
			() => {
				this.loadData();
			}
		);
	}
	doReset() {
		this.setState(
			{
				search: JSON.parse(JSON.stringify(this.state.APIResetData)),
				APISearchData: JSON.parse(JSON.stringify(this.state.APIResetData)),
				isRefreshing: true,
			},
			() => {
				this.loadData();
			}
		);
	}
	handleFocus = (event) => event.target.select();
	setCreatedDateRange(start, end) {
		var tmpObj = this.state.search;
		tmpObj.createdFrom = start;
		tmpObj.createdTo = end;
		this.setState({ search: tmpObj });
	}
	setClosedDateRange(start, end) {
		var tmpObj = this.state.search;
		tmpObj.closedFrom = start;
		tmpObj.closedTo = end;
		this.setState({ search: tmpObj });
	}
	validateMobile(mobile) {
		if (mobile.trim() == "") {
			return false;
		}
		return mobile.match(/^(0)+(9|$)\d{9}$/g) != null;
	}
	toggleSearchForm() {
		const prevState = this.state.toggleSearchForm;
		this.setState({
			toggleSearchForm: !prevState,
		});
	}

	render() {
		return this.state.isLoading ? (
			<div className="loading"></div>
		) : (
			<Fragment>
				<Row className="mb-4 searchdropdown">
					<Colxx xxs="12">
						<Card>
							<CardBody>
								<ReportScope scope={this.state.search.reportContext} error={this.state.reportError} />
								<CardTitle>
									<div
										onClick={(e) => {
											this.props.history.push("/app/crm/customer/");
										}}
										className="breadcrumb-item"
									>
										<div className={"iconsminds-business-man-woman headingicon"} /> مشتری ها
									</div>
									<span className="breadcrumb-arrow" style={{ marginLeft: "10px" }}>
										{" > "}
									</span>
									{this.props.match.params.customerTagID !== undefined ? (
										<span style={{ marginRight: "-25px" }}>
											<div
												onClick={(e) => {
													this.props.history.push("/app/crm/customer/" + this.props.match.params.customerTagID);
												}}
												className="breadcrumb-item"
											>
												<div className={"iconsminds-tag headingicon"} /> {this.state.customerTagName}
											</div>
											<span className="breadcrumb-arrow" style={{ marginLeft: "10px" }}>
												{" > "}
											</span>
										</span>
									) : (
										<span />
									)}

									<div className={"iconsminds-data-center headingicon"} />
									{classNames({
										"گزارش همه مشتری ها": this.props.match.params.listType === undefined,
										"گزارش همه مشتری ها با سفارش موفق": this.props.match.params.listType === "with-success",
										"گزارش همه مشتری ها فقط با سفارش ناموفق": this.props.match.params.listType === "only-failed",
										"گزارش همه مشتری ها با چند سفارش موفق": this.props.match.params.listType === "multi-success",
									})}
									{this.props.match.params.customerTagID !== undefined ? (
										<span>
											{" "}
											با برچسب <strong style={{ textDecoration: "underline" }}>{this.state.customerTagName}</strong>
										</span>
									) : (
										<span />
									)}

									<div className={"text-muted"} style={{ float: "left", fontSize: "14px" }}>
										{" نمایش "}
										{<NumberFormat value={this.state.paging.from + 1} displayType={"text"} thousandSeparator={true} renderText={(value, prop) => <span>{value}</span>} />}
										{" تا "}
										{<NumberFormat value={this.state.paging.to} displayType={"text"} thousandSeparator={true} renderText={(value, prop) => <span>{value}</span>} />}
										{" از "}
										{<NumberFormat value={this.state.paging.total} displayType={"text"} thousandSeparator={true} renderText={(value, prop) => <span>{value}</span>} />}
										{" مشتری"}
									</div>
								</CardTitle>

								<Fragment>
									<div className="border productPanel" >
										<Button  block color="link" className="text-right" onClick={() => this.toggleSearchForm()} aria-expanded={this.state.toggleSearchForm}>
											<i className="glyph-icon simple-icon-magnifier" style={{ marginLeft: "5px", fontSize: "14px" }}></i>
											فرم جستجو
											<i className="glyph-icon simple-icon-arrow-down" style={{ marginRight: "10px", fontSize: "10px" }}></i>
										</Button>
										<div
											className="dropdown-buttons"
											style={{
												float: "left",
												display: this.state.toggleSearchForm ? "inline-block" : "none",
											}}
										>
											<Button
												color="info"
												style={{ float: "left", padding: 5, paddingTop: 8 }}
												className={"default sms-send-button"}
												onClick={() => {
													this.setState({ smsModalOpen: true });
												}}
												disabled={this.state.sms_searchChanged}
											>
												<i
													className="iconsminds-mail-send"
													style={{
														fontSize: 24,
														fontWeight: 800,
														height: 20,
														display: "inline-block",
													}}
												></i>
												&nbsp;
											</Button>
											<Button
												color="primary"
												className={"default"}
												style={{
													float: "left",
													marginLeft: "10px",
												}}
												onClick={this.doSearch}
											>
												جستجو کن
											</Button>
											<Button
												color="light"
												style={{
													float: "left",
													marginLeft: "10px",
												}}
												className={"default"}
												onClick={this.doReset}
											>
												ریست
											</Button>
											<Modal onOpened={this.smsModalOpened} isOpen={this.state.smsModalOpen} toggle={this.smsModalToggle}>
												<ModalHeader toggle={this.smsModalToggle}>ارسال پیامک دسته ای</ModalHeader>
												<ModalBody>
													<table>
														<tbody>
															<tr>
																<th>نوع:</th>
																<td>مشتری</td>
															</tr>
															<tr>
																<th>تعداد کل:</th>
																<td>{<NumberFormat value={this.state.paging.total} displayType={"text"} thousandSeparator={true} renderText={(value, prop) => <span>{value}</span>} />}</td>
															</tr>
															<tr>
																<th>فیلتر ها:</th>
																<td>
																	<pre
																		style={{
																			direction: "ltr !important",
																			textAlign: "left",
																			width: "330px",
																		}}
																		className={"jsonsyntax"}
																		dangerouslySetInnerHTML={{
																			__html: this.syntaxHighlight(JSON.stringify(this.smsFilters(), null, 2)),
																		}}
																	></pre>
																</td>
															</tr>
															<tr>
																<th>دسته:</th>
																<td>
																	<Input
																		type="select"
																		onChange={(e) => {
																			this.setState({
																				sms_targetBatchID: e.target.value,
																				sms_targetBatchMessage: this.state.sms_batches.filter(function (batch) {
																					return batch.BatchID == e.target.value;
																				})[0].Message,
																			});
																		}}
																		value={this.state.sms_targetBatchID}
																	>
																		<option value="-1" data-message="">
																			{this.state.sms_isBatchesLoading ? "..." : "انتخاب کنید"}
																		</option>
																		{this.state.sms_batches.map((batch) => (
																			<option key={"batch-" + batch.BatchID} data-message={batch.Message} value={batch.BatchID}>
																				{batch.Name}
																			</option>
																		))}
																	</Input>
																</td>
															</tr>
															<tr>
																<th>پیام:</th>
																<td>
																	<div
																		style={{ background: "#e5e5ea", width: "330px", padding: "10px", borderRadius: "10px", float: "Left", borderBottomLeftRadius: "" }}
																		dangerouslySetInnerHTML={{
																			__html: this.state.sms_targetBatchMessage,
																		}}
																	></div>
																</td>
															</tr>
														</tbody>
													</table>
												</ModalBody>
												<ModalFooter>
													<Button
														color="info"
														style={{ float: "left" }}
														className={"default"}
														onClick={() => {
															this.smsSend();
														}}
														disabled={this.state.sms_searchChanged || this.state.sms_isSending}
													>
														ارسال
													</Button>
												</ModalFooter>
											</Modal>
										</div>
										<Collapse isOpen={this.state.toggleSearchForm} style={{paddingTop:"10px"}}>
											<div className="p-4">
												<Row className="mb-4">
													<Colxx xxs="12">
														<Form>
															<FormGroup row>
																<Colxx sm={2}>
																	<FormGroup className={"filter " + (this.validateMobile(this.state.search.customerMobile) ? "filter-active" : "")}>
																		<Label for="customerMobile">موبایل مشتری ( شروع با )</Label>
																		<Input
																			type="text"
																			name="customerMobile"
																			id="customerMobile"
																			onClick={this.handleFocus}
																			placeholder="09123456789"
																			value={this.state.search.customerMobile}
																			onChange={(e) => {
																				this.setState({ sms_searchChanged: true });
																				var cleanValue = this.cleanCustomerMobile(e.target.value);
																				var tmpObj = { ...this.state.search };
																				tmpObj.customerMobile = cleanValue;
																				this.setState({ search: tmpObj });
																			}}
																		/>
																	</FormGroup>
																</Colxx>
																<Colxx sm={2}>
																	<FormGroup className={"filter " + (this.state.search.basicInfo != "ALL" ? "filter-active" : "")}>
																		<Label>اطلاعات پایه</Label>
																		<Input
																			type="select"
																			onChange={(e) => {
																				this.setState({ sms_searchChanged: true });
																				var tmpObj = { ...this.state.search };
																				tmpObj.basicInfo = e.target.value;
																				this.setState({ search: tmpObj });
																			}}
																			value={this.state.search.basicInfo}
																		>
																			<option value="ALL">همه</option>
																			<option value="WITH_BASICINFO">فقط با اطلاعات پایه</option>
																			<option value="NO_BASICINFO">فقط بدون اطلاعات پایه</option>
																		</Input>
																	</FormGroup>
																</Colxx>
																<Colxx sm={2}>
																	<FormGroup className={"filter " + (this.state.search.gender != "ALL" ? "filter-active" : "")}>
																		<Label>جنسیت</Label>
																		<Input
																			type="select"
																			onChange={(e) => {
																				this.setState({ sms_searchChanged: true });
																				var tmpObj = { ...this.state.search };
																				tmpObj.gender = e.target.value;
																				this.setState({ search: tmpObj });
																			}}
																			value={this.state.search.gender}
																		>
																			<option value="ALL">همه</option>
																			<option value="MALE">فقط آقا</option>
																			<option value="FEMALE">فقط خانم</option>
																		</Input>
																	</FormGroup>
																</Colxx>
																<Colxx sm={2}>
																	<FormGroup className={"filter " + (this.state.search.smsBanned != "ALL" ? "filter-active" : "")}>
																		<Label>دریافت پیامک</Label>
																		<Input
																			type="select"
																			disabled={this.props.match.params.smsBannedType == "converted"}
																			onChange={(e) => {
																				this.setState({
																					sms_searchChanged: true,
																				});
																				var tmpObj = {
																					...this.state.search,
																				};
																				tmpObj.smsBanned = e.target.value;
																				this.setState({
																					search: tmpObj,
																				});
																			}}
																			value={this.state.search.smsBanned}
																		>
																			<option value="ALL">همه</option>
																			<option value="BANNED">مسدود</option>
																		</Input>
																	</FormGroup>
																</Colxx>
																<Colxx sm={3}>
																	<FormGroup
																		className={
																			"filter " +
																			((this.state.search.customerName != "" && this.state.search.customerName.length > 2) || (this.state.search.customerSurName != "" && this.state.search.customerSurName.length > 2)
																				? "filter-active"
																				: "")
																		}
																	>
																		<Label for="customername">نام مشتری:</Label>
																		<span
																			style={{
																				border: "1px solid lightgray",
																				borderRadius: "5px",
																				background: "#eaeaea",
																				cursor: "pointer",
																				marginRight: 10,
																				display: "inline-block",
																				width: "25px",
																				textAlign: "center",
																				paddingTop: "5px",
																			}}
																			onClick={(e) => {
																				this.setState({ sms_searchChanged: true });
																				var tmpObj = { ...this.state.search };
																				tmpObj.nameOperator = this.state.search.nameOperator == "=" ? "<>" : "=";
																				this.setState({ search: tmpObj });
																			}}
																		>
																			{this.state.search.nameOperator == "=" ? "=" : "<>"}
																		</span>
																		<br />
																		<Input
																			type="text"
																			name="customername"
																			id="customername"
																			onClick={this.handleFocus}
																			placeholder=" نام"
																			style={{ width: "calc(50% - 5px)", display: "inline-block", marginLeft: "5px" }}
																			value={this.state.search.customerName}
																			onChange={(e) => {
																				this.setState({ sms_searchChanged: true });
																				var tmpObj = { ...this.state.search };
																				tmpObj.customerName = e.target.value;
																				this.setState({ search: tmpObj });
																			}}
																		/>
																		<Input
																			type="text"
																			name="customersurname"
																			id="customersurname"
																			onClick={this.handleFocus}
																			placeholder="  نام خانوادگی"
																			style={{ width: "calc(50% - 5px)", display: "inline-block" }}
																			value={this.state.search.customerSurName}
																			onChange={(e) => {
																				this.setState({ sms_searchChanged: true });
																				var tmpObj = { ...this.state.search };
																				tmpObj.customerSurName = e.target.value;
																				this.setState({ search: tmpObj });
																			}}
																		/>
																	</FormGroup>
																</Colxx>
															</FormGroup>
														</Form>
													</Colxx>
												</Row>
											</div>
										</Collapse>
									</div>
									<br />
								</Fragment>
								{!this.state.isRefreshing ? (
									<div className="table-responsive">
										<table className="table table-hover order-table">
											<thead>
												<tr>
													<th>موبایل</th>
													<th>جنسیت</th>
													<th>نام </th>
													<th>نام خانوادگی </th>
													<th>اطلاعات پایه </th>
													<th>سن</th>
													<th>جمع کل سفارش های موفق</th>
													<th>سفارش موفق </th>
													<th>سفارش کنسلی</th>
													<th>سفارش جاری</th>
													<th>
														<i className={"iconsminds-mail-settings"} ></i>
													</th>
												</tr>
											</thead>

											{this.state.customers.map((row) => (
												<TableBodyRows key={row.CustomerId} data={row} />
											))}

											<tfoot>
												<tr>
													<td colSpan={12}>
														<div className="table-pagination">
															{this.state.paging.pages.map((page, index) => (
																<Button
																	key={index}
																	className={classNames({ "mb-2": true, "pagination-item": true, "pagination-number": true, "pagination-current": page.current })}
																	onClick={(e) => {
																		if (page.ellipse) {
																			return;
																		}
																		var tmpObj = { ...this.state.APISearchData };
																		tmpObj.currentPage = page.page;
																		console.log(page.page, tmpObj.currentPage);
																		this.setState({ APISearchData: tmpObj, isRefreshing: true }, () => {
																			this.loadData();
																		});
																	}}
																>
																	{page.page}
																</Button>
															))}
														</div>
													</td>
												</tr>
											</tfoot>
										</table>
									</div>
								) : (
									<div className="loading" style={{ left: "unset", top: "unset", position: "relative", display: "block", marginLeft: "auto", marginRight: "auto" }}></div>
								)}
							</CardBody>
						</Card>
					</Colxx>
				</Row>
			</Fragment>
		);
	}
}

class TableBodyRows extends Component {
	render() {
		const {
			data: { CustomerID, Name, SurName, Mobile, Age, Gender, BasicInfoLock, SumSuccess, CountSuccess, CountFailed, CountCurrent,smsBanned },
		} = this.props;
		const GENDER_MAP = [];
		GENDER_MAP["MALE"] = "آقا";
		GENDER_MAP["FEMALE"] = "خانم";
		return (
			<tbody>
				<tr className={"order-spacer"}></tr>
				<tr className={"order-item"}>
					<td>
						<a href={"/app/customers/view-customer/" + Mobile} target="_blank"> 
							{" "}
							{Mobile} <div className={" simple-icon-arrow-left-circle icongotoorder"} />
						</a>
					</td>
					<td className={"text-muted"}>{GENDER_MAP[Gender]}</td>
					<td className={"text-muted"}>{Name}</td>
					<td className={"text-muted"}>{SurName}</td>
					<td className={"text-muted"}>
						<div
							className={classNames({
								"simple-icon-check": BasicInfoLock === "1",
								"simple-icon-options": BasicInfoLock === "0",
							})}
						/>
					</td>
					<td className={"text-muted"}>{Age}</td>
					<td className={"text-muted"}>{<NumberFormat value={SumSuccess} displayType={"text"} thousandSeparator={true} suffix={" تومان"} renderText={(value, prop) => <span>{value}</span>} />}</td>
					<td className={"text-muted"}>{<NumberFormat value={CountSuccess} displayType={"text"} thousandSeparator={true} renderText={(value, prop) => <span>{value}</span>} />}</td>
					<td className={"text-muted"}>{<NumberFormat value={CountFailed} displayType={"text"} thousandSeparator={true} renderText={(value, prop) => <span>{value}</span>} />}</td>
					<td className={"text-muted"}>{<NumberFormat value={CountCurrent} displayType={"text"} thousandSeparator={true} renderText={(value, prop) => <span>{value}</span>} />}</td>
					<td className={"text-muted"}><i style={{color:smsBanned ? "darkorange":"#98abb4",fontWeight: smsBanned ? "bold":"default"}}className={classNames({
						'simple-icon-ban':smsBanned,
						'simple-icon-check':!smsBanned
					})}></i></td>
				</tr>
			</tbody>
		);
	}
}

const mapStateToProps = ({ menu, settings }) => {
	return { logoutUser };
};
export default injectIntl(connect(mapStateToProps, { logoutUser })(archive));
// export default injectIntl(archive);
